import { render, staticRenderFns } from "./ApplyRegist.vue?vue&type=template&id=4244cf83&scoped=true"
import script from "./ApplyRegist.vue?vue&type=script&lang=js"
export * from "./ApplyRegist.vue?vue&type=script&lang=js"
import style0 from "./ApplyRegist.vue?vue&type=style&index=0&id=4244cf83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4244cf83",
  null
  
)

export default component.exports